import { render, staticRenderFns } from "./SelectShelfPeriodPriceComponent.vue?vue&type=template&id=55bcc605&scoped=true"
import script from "./SelectShelfPeriodPriceComponent.vue?vue&type=script&lang=js"
export * from "./SelectShelfPeriodPriceComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectShelfPeriodPriceComponent.vue?vue&type=style&index=0&id=55bcc605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bcc605",
  null
  
)

export default component.exports